import React, {useState} from 'react'
import styled from 'styled-components'
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import emailjs from "@emailjs/browser"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import contact from "../assets/contact.png"

emailjs.init({
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
})

const ContactSection = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const blockedDomains = ["mailinator.com", "yopmail.com", "tempmail.com", "fakeinbox.com"];

    const isValidDomain = (email) => {
        const domain = email.split('@')[1];
        return !blockedDomains.includes(domain);
    };
    

    const isValidEmail = (email) => {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) &&
               email.includes(".") &&  // Must contain a dot
               !email.endsWith(".") &&  // Can't end with a dot
               email.split('@')[1].split('.').length > 1; // Must have a domain part
    };

    

    const sendEmail = (e) => {
        e.preventDefault();

        if (!name || !email || !message) {
            toast.error("Fyll ut alle felt!");
            return;
        }

        if (!isValidDomain(email)) {
            toast.error("Temporary email addresses are not allowed!");
            return;
        }

        if (!isValidEmail(email)) {
            toast.error("Invalid email address!");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            message: message
        };

        emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            templateParams,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        ).then(response => {
            toast.success("Email er sendt!");
            setName("");
            setEmail('');
            setMessage('');
        }).catch(error => {
            toast.error("Failed to send email. Prøv på nytt!");
            console.error("Email Error", error)
        })
    }

    return (
        <Container id='contact'>
            <Header>Kontakt Oss</Header>
            <ContactBox>
                <LeftSection>
                    <Title>Lurer Du På Noe</Title>
                    <Subtitle>Vi er her for deg! Hvordan kan vi hjelpe?</Subtitle>
                    <Form onSubmit={sendEmail}>
                        <Input
                            type="text" 
                            placeholder="Ditt Navn" 
                            value={name} 
                            onChange={(e) => setName(e.target.value)}
                        />
                        
                        <Input 
                            type="email" 
                            placeholder="Placeholder@email.com" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <Textarea
                            placeholder="Go ahead, we are listening..." 
                            value={message} 
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        <SubmitButton type='submit'>Send</SubmitButton>
                    </Form>
                    <ToastContainer position="bottom-right" autoClose={3000} />
                </LeftSection>
                
                <RightSection>
                    <Illustration>
                        <img src={contact} alt="Contact Us" />
                    </Illustration>
                    
                    <ContactInfo>
                        <InfoItem>
                            <FaMapMarkerAlt size={18} color="#2d6a4f" />
                            <span>Osloveien 81, 0889 Oslo</span>
                        </InfoItem>
                        <InfoItem>
                            <FaPhoneAlt size={18} color="#2d6a4f" />
                            <span>+47 123 45 678</span>
                        </InfoItem>
                        <InfoItem>
                            <FaEnvelope size={18} color="#2d6a4f" />
                            <span>kontakt@wildberries.no</span>
                        </InfoItem>
                    </ContactInfo>
                    <SocialIcons>
                        <FaFacebook size={20} />
                        <FaTwitter size={20} />
                        <FaLinkedin size={20} />
                    </SocialIcons>
                </RightSection>
            </ContactBox>
        </Container>
    )
}

export default ContactSection

const Container = styled.div`
    width: 100%;
    background-color: #2d6a4f;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    margin-top: 60px;
`;

const Header = styled.header`
    font-size: 2rem;
    font-weight: bold;
    color: white;
    width: 100%;
    text-align: center;
    padding: 1rem 0;
`;

const ContactBox = styled.div`
    display: flex;
    background: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    max-width: 1000px;
    width: 100%;
    margin-top: 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`;

const LeftSection = styled.div`
    flex: 1;
    padding: 2rem;
    background: white;
`;

const Title = styled.h2`
    font-size: 1.8rem;
    font-weight: bold;
    color: #2d6a4f;
`;

const Subtitle = styled.p`
    font-size: 1rem;
    color: #4a4a4a;
    margin: 0.5rem 0 1.5rem;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Input = styled.input`
    width: 100%;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
`;

const Textarea = styled.textarea`
    width: 100%;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    height: 100px;
    outline: none;
`;

const SubmitButton = styled.button`
    width: 100%;
    background-color: #2d6a4f;
    color: white;
    padding: 0.8rem;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background-color: #245c40;
    }
`;

const RightSection = styled.div`
    flex: 1;
    padding: 2rem;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
`;

const Illustration = styled.div`
    img {
        width: 100%;
        height: auto;
    }
`;

const ContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const InfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    color: #2d6a4f;
`;

const SocialIcons = styled.div`
    display: flex;
    gap: 1rem;

    svg {
        cursor: pointer;
        color: #2d6a4f;
        transition: all 0.3s;

        &:hover {
            color: #245c40;
            scale: 1.2;
        }
    }
`;